const getCurrentWeekYear = () => {
    // Set Melbourne timezone offset (AEST: UTC+10, AEDT: UTC+11)
    const melbourneOffset = new Date().getTimezoneOffset() + 600; // 600 minutes offset for UTC+10
    // Get current date and time in Melbourne time
    const date = new Date(new Date().getTime() + melbourneOffset * 60000);
    const year = date.getFullYear();
    const week = getWeekNumber(date).toString().padStart(2, '0'); // Get the week number and pad with leading zero if needed
    return `${week}-${year}`;
};
// Helper const to get the week number
const getWeekNumber = (date) => {
    const startOfYear = new Date(date.getFullYear(), 0, 1);
    const pastDaysOfYear = (date - Number(startOfYear)) / 86400000;
    return Math.ceil((pastDaysOfYear + startOfYear.getDay() + 1) / 7);
};
const getMelbourneDateString = () => {
    // Define the Melbourne time zone
    const melbourneTimeZone = 'Australia/Melbourne';
    // Create a new Date object and format it directly
    const nowInMelbourne = new Date().toLocaleDateString('en-CA', {
        timeZone: melbourneTimeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
    return nowInMelbourne; // Returns the date in YYYY-MM-DD format
};
// Classic UUID4
const generateUUIDv4 = () => {
    // Generate a random UUIDv4
    return 'xxxxxxxx_xxxx_4xxx_yxxx_xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};
const generateUID = () => {
    return 'xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};
const generateDateID = () => {
    const melbourneOffset = new Date().getTimezoneOffset() + 600; // 600 minutes offset for UTC+10
    const date = new Date(new Date().getTime() + melbourneOffset * 60000);
    const year = date.getFullYear().toString();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // getMonth() returns month from 0-11, so add 1
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const milliseconds = date.getMilliseconds().toString().padStart(3, '0');
    return `${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
};
export { getWeekNumber, getCurrentWeekYear, generateDateID, getMelbourneDateString, generateUID };
